export const deviceTypes = {
  bend: 'bend',
  armband: 'armband',
};
